import React from "react";
import { Routes, Route } from "react-router-dom";
import ListFranchise from "../Components/Franchise/listFranchise";
import ViewFranchise from "../Components/Franchise/viewFranchise";
import AddFranchise from "../Components/Franchise/addFranchise";
import Editfranchise from "../Components/Franchise/editFranchise";
import AssignBuilderList from "../Components/Franchise/assignBuilderList";
import AssignBuilder from "../Components/Franchise/assignBuilder";
import ProjectList from "../Components/Franchise/projectsList";
import AssignProjectList from "../Components/Franchise/assignProjectList";
import FormAssignBuilder from "../Components/Franchise/formAssignBuilders";
import FormAssignProjects from "../Components/Franchise/formAssignProjectList";
import ProjectCatalogueList from "../Components/Franchise/projectCatalogueList";
import ViewCommercialCatalogue from "../Components/Franchise/commercialCatalogue";
import ViewResidentialCatalogue from "../Components/Franchise/residentialCatalogue";
import PlotCatalogue from "../Components/Franchise/plotCatalogue";
import AssignProjectCatalogue from "../Components/Franchise/assignProjectCatalogue";

const FranchiseRoutes = () => {
  return (
    <Routes>
      <Route
        path="/franchise"
        element={<ListFranchise></ListFranchise>}
      ></Route>
      <Route
        path="/franchise/view/:id"
        element={<ViewFranchise></ViewFranchise>}
      ></Route>
      <Route
        path="/franchise/add"
        element={<AddFranchise></AddFranchise>}
      ></Route>
      <Route
        path="/franchise/edit/:id"
        element={<Editfranchise></Editfranchise>}
      ></Route>
      <Route
        path="/franchise/assign-builder-list/:id"
        element={<AssignBuilderList></AssignBuilderList>}
      ></Route>
      <Route
        path="/franchise/assign-builder/:id"
        element={<AssignBuilder></AssignBuilder>}
      ></Route>
      <Route
        path="/franchise/form-assign-builder"
        element={<FormAssignBuilder></FormAssignBuilder>}
      ></Route>
      <Route
        path="/franchise/form-assign-project"
        element={<FormAssignProjects></FormAssignProjects>}
      ></Route>
      <Route
        path="/franchise/projects_list"
        element={<ProjectList></ProjectList>}
      ></Route>
      <Route
        path="/franchise/assign_projects"
        element={<AssignProjectList></AssignProjectList>}
      ></Route>
      <Route
        path="/franchise/project_catalogue_list"
        element={<ProjectCatalogueList></ProjectCatalogueList>}
      ></Route>
      <Route
        path="/franchise/commercial_catalogue_list/:category_id/:project_type/:project_id"
        element={<ViewCommercialCatalogue></ViewCommercialCatalogue>}
      ></Route>
      <Route
        path="/franchise/residential_catalogue_list/:category_id/:project_type/:project_id"
        element={<ViewResidentialCatalogue></ViewResidentialCatalogue>}
      ></Route>
      <Route
        path="/franchise/plot_catalogue_list/:category_id/:project_type/:project_id"
        element={<PlotCatalogue></PlotCatalogue>}
      ></Route>
      <Route
        path="/franchise/assign_projects_catalogue"
        element={<AssignProjectCatalogue></AssignProjectCatalogue>}
      ></Route>
    </Routes>
  );
};

export default FranchiseRoutes;
